module.exports = __webpack_public_path__ + "e94cdf4d722dd97b8be431cf343615c2.svg";